import { motion } from "framer-motion";
import { Eyebrow, SerifH } from "./shared";

export function About() {
  return (
    <section id="about" data-testid="about" className="bg-[#F4EDE2] text-[#0C111C]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-24 md:py-32 grid lg:grid-cols-12 gap-10 lg:gap-14">
        {/* Left: heading + atelier card */}
        <div className="lg:col-span-5">
          <Eyebrow>About YABA</Eyebrow>
          <SerifH className="mt-4" size="clamp(32px, 4vw, 64px)">
            A jellaba for the way we live now.
          </SerifH>

          <motion.figure
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            data-testid="about-atelier-card"
            className="mt-10 border border-[#0C111C]/12 bg-[#EDE2CE]/60 backdrop-blur-sm p-5 md:p-6 flex items-stretch gap-5 md:gap-6"
          >
            <div className="w-28 h-28 md:w-36 md:h-36 shrink-0 overflow-hidden bg-[#0C182E]">
              <img
                src="/yaba_detail_sfifa.jpg"
                alt="Rachid Bennani at work on the sfifa braid"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="flex flex-col justify-between min-w-0">
              <div>
                <p
                  className="text-[10px] tracking-[0.28em] uppercase text-[#C8A96A]"
                  style={{ fontFamily: "Inter, sans-serif" }}
                >
                  Meet the atelier
                </p>
                <p
                  className="mt-2 text-2xl leading-tight"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  Rachid Bennani
                </p>
                <p
                  className="mt-1 text-sm text-[#3A3A3E]"
                  style={{ fontFamily: "Inter, sans-serif" }}
                >
                  Head sfifa stitcher · 18 years in Fes
                </p>
              </div>
              <p
                className="mt-3 text-[14px] leading-relaxed text-[#0C111C]/80 italic"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                "Six hours per collar. If the thread doesn't sing, we take it out."
              </p>
            </div>
          </motion.figure>
        </div>

        {/* Right: paragraphs + certification pills */}
        <div
          className="lg:col-span-6 lg:col-start-7 space-y-6 text-base md:text-lg text-[#3A3A3E]"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          <p>
            YABA was born from a simple frustration: the traditional jellaba is one of the most elegant, breathable, timeless garments ever designed — yet nowhere could we find one made with modern silhouette, real premium fabric, and the everyday features a contemporary wardrobe needs.
          </p>
          <p>
            So we built it. We partnered with a family atelier in the medina of Fes, sourced OEKO-TEX-certified viscose, added deep hidden pockets, cut the fit for movement, and made every piece machine-washable. We kept the sfifa braid hand-stitched — because some things you don't modernise.
          </p>
          <p>
            Today YABA ships from Morocco to more than sixty countries. Each jellaba passes through the hands of fourteen artisans over eighteen to twenty-two hours of work. And every drop is a limited run — because when a garment is this considered, it deserves to be worn by people who see it that way too.
          </p>
          <div
            className="pt-4 flex flex-wrap gap-3 text-[#0C111C]"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            {[
              "OEKO-TEX certified viscose",
              "Fair-wage atelier partnership",
              "Ships duty-paid to 60+ countries",
            ].map((c) => (
              <span key={c} className="rounded-full border border-[#0C111C]/20 px-4 py-2 text-sm">
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
